import React, { Component } from "react";
import { connect } from "react-redux";
import Modal from "../common/Modal";
import { addAdmin } from "../../actions/authActions";

export class EditUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      password: ""
    };
  }
  handleCancelAddUser = () => {
    this.props.handleCancelAddUser();
  };
  handleSubmit = e => {
    e.preventDefault();
    const { name, email, password } = this.state;
    const addData = {
      name,
      email,
      password,
      role_id: 1
    };
    this.props.addAdmin(addData);
    this.setState({ name: "", email: "", password: "" });
    this.props.handleCancelAddUser();
  };
  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };
  render() {
    const { name, email, password } = this.state;
    return (
      <Modal
        id="addUser"
        key="addUser"
        open={true}
        size={"small"}
        header="Add User"
        onClose={this.handleCancelAddUser}
      >
        <div className="row">
          <div className="col-md-12">
            <form onSubmit={this.handleSubmit}>
              <div className="box-body">
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    name="name"
                    placeholder="Name"
                    value={name}
                    onChange={this.handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    placeholder="Email"
                    value={email}
                    onChange={this.handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    name="password"
                    placeholder="Password"
                    value={password}
                    onChange={this.handleChange}
                    required
                  />
                </div>
              </div>
              <div className="box-footer" style={{ textAlign: "center" }}>
                <button type="submit" className="btn btn-primary">
                  Add
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default connect(mapStateToProps, { addAdmin })(EditUser);



// WEBPACK FOOTER //
// ./src/components/Admin/AddAdmin.js